.dialog-content-container{display:flex;flex-direction:column;align-items:center}.error{color:#bf192a}h3-sama-logo{transform:scale(2)}[mat-dialog-title]{margin-bottom:10px}
/*# sourceMappingURL=multi-tabs-opened-modal.component.css.map */
